"use strict";
// models/libelles.js
Object.defineProperty(exports, "__esModule", { value: true });
exports.codesPostaux = exports.profilUtilisateurList = void 0;
const globals_1 = require("models/globals");
exports.profilUtilisateurList = new webix.DataCollection({
    url: globals_1.phpPath + "libelles.php?option=profilUtilisateur"
});
exports.codesPostaux = new webix.DataCollection({
    url: globals_1.phpPath + "codesPostaux.php"
});
